import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TbTableDashed } from "react-icons/tb";
import { LayoutGrid, Bot, Lightbulb /* , Workflow */ } from "lucide-react";
import { openAgentStudio } from "../../config/environment";
import { useAuth } from "../Context/authContext";

const Sidebar = ({ isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    console.log("[Productive] Sidebar mounted", {
      brainstormingNav: true,
      path: location.pathname,
      loggedIn: Boolean(user),
    });
  }, [location.pathname, user]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleAgentStudioNavigation = () => {
    if (!user) {
      alert("Please login to access Agent Studio");
      navigate("/login");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const first_name = user?.first_name || localStorage.getItem("first_name") || "";
      const last_name = user?.last_name || localStorage.getItem("last_name") || "";
      const userEmail = localStorage.getItem("userEmail");
      const refreshToken = localStorage.getItem("refreshToken");
      const userId = localStorage.getItem("userId");
      const api_key = localStorage.getItem("api_key") || user?.api_key;

      if (!token) {
        alert("Session expired. Please login again.");
        navigate("/login");
        return;
      }

      const displayName = [first_name, last_name].filter(Boolean).join(" ") || user.email || userEmail;

      const userData = {
        name: displayName,
        organization: "Fouray's organization",
        plan: "Community Plan",
        email: user.email || userEmail,
        first_name,
        last_name,
      };

      openAgentStudio({
        token,
        first_name,
        last_name,
        userEmail,
        api_key,
        refreshToken,
        userId,
        userData,
        timestamp: Date.now(),
      });
    } catch (error) {
      console.error("Error preparing Agent Studio:", error);
      alert("Error preparing Agent Studio. Please try again.");
    }
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`} style={{ zIndex: 999 }}>
      <ul className="nav-list">
        <li
          className={`nav-item ${
            location.pathname === "/" ? "active-sidebar" : ""
          }`}
          onClick={() => handleNavigation("/")}
        >
          <TbTableDashed className="nav-icon" />
          {isOpen && <span className="nav-des">Dashboard</span>}
        </li>

        <li
          className={`nav-item ${
            location.pathname === "/skills" || location.pathname.startsWith("/skills/")
              ? "active-sidebar"
              : ""
          }`}
          onClick={() => handleNavigation("/skills")}
        >
          <LayoutGrid className="nav-icon" />
          {isOpen && <span className="nav-des">Skills</span>}
        </li>

        <li
          className={`nav-item ${
            location.pathname === "/brainstorming" ||
            location.pathname.startsWith("/brainstorming/")
              ? "active-sidebar"
              : ""
          }`}
          onClick={() => handleNavigation("/brainstorming")}
        >
          <Lightbulb className="nav-icon" />
          {isOpen && <span className="nav-des">Brainstorming</span>}
        </li>

        {/* Automation tab — hidden for now
        <li
          className={`nav-item ${
            location.pathname.startsWith("/automation") ? "active-sidebar" : ""
          }`}
          onClick={() => handleNavigation("/automation")}
        >
          <Workflow className="nav-icon" />
          {isOpen && <span className="nav-des">Automation</span>}
        </li>
        */}

        <li className="nav-item" onClick={handleAgentStudioNavigation}>
          <Bot className="nav-icon" />
          {isOpen && <span className="nav-des">Agent Studio</span>}
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
